module.exports = __webpack_public_path__ + "img/stackslash-process-3-mobile.ef1a403b.jpg";